import * as Cookie from 'js-cookie';

import { DevelopmentToolsActionType } from '../../typings/dev';

export const getFakeAuthName = (): string | undefined => {
    return Cookie.get(DevelopmentToolsActionType.fakeAuth);
};

export const getActiveDevelopmentTools = (): Array<DevelopmentToolsActionType> => {
    const developmentTools = [
        DevelopmentToolsActionType.fakeAuth,
        DevelopmentToolsActionType.showCaptcha,
        DevelopmentToolsActionType.dumpVars
    ];

    return developmentTools.filter(tool => Boolean(Cookie.get(tool)));
};
